module.exports = __webpack_public_path__ + "ef30b049b78b2ed7814fcdb339fb2c62.pdf";